import { useEffect, useState } from 'react';
import { getCanvasMessages } from '../utils/canvasI18n';

const STAGE_INTERVAL_MS = 2400;

export function useAiThinkingStatus(active, variant = 'context', language = 'en') {
  const stages = getCanvasMessages(language).thinking[variant]
    || getCanvasMessages(language).thinking.context;
  const [stageIndex, setStageIndex] = useState(0);
  const lastIndex = stages.length - 1;

  useEffect(() => {
    if (!active) {
      setStageIndex(0);
      return undefined;
    }

    // Progress once; hold on the last stage instead of looping.
    if (stageIndex >= lastIndex) return undefined;

    const timer = setTimeout(() => {
      setStageIndex(index => Math.min(index + 1, lastIndex));
    }, STAGE_INTERVAL_MS);

    return () => clearTimeout(timer);
  }, [active, lastIndex, stageIndex]);

  if (!active) return null;
  return stages[stageIndex];
}
